/**
 * Parses a comma/semicolon separtated list of 4 digit positive years and year
 * ranges. Can be used as user input validator and parser.
 * @param {*} input e.g. "2010-2014, 2016" 
 */
const parseYears = input => {

    let ret = {
        valid: true,
        values: [],
    }

    let splitted = input
        .replace(/ /g,'')
        .split(/[,;]/g)

    splitted.map(part => {
        if (part.indexOf('-') === -1) {
            if (part === '' || isNaN(Number(part)) || part.length !== 4) {
                ret.valid = false
            } else {
                ret.values.push(Number(part))
            }
        } else {
            let startEnd = part.split('-')

            if(startEnd.length !== 2) {
                ret.valid = false
                return
            }

            if(startEnd[0] === '' || startEnd[1] === '') {
                ret.valid = false
                return
            }

            if(startEnd[0].length !== 4 || startEnd[1].length !== 4) {
                ret.valid = false
                return
            }

            let start = Number(startEnd[0])
            let end = Number(startEnd[1])

            if( isNaN(start) || isNaN(end)) {
                ret.valid = false
                return
            }

            if(start <= end) {
                for(let i = start; i <= end; i++ ) {
                    ret.values.push(i)
                }
            } else {
                for(let i = start; i >= end; i-- ) {
                    ret.values.push(i)
                }
            }
        }
    })

    if(ret.valid === false) {
        ret.values = []
    }

    return ret

}

export default parseYears